import React, { Component } from 'react';

export default class nameFranchiseCellRenderer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { franchiseInfo } = this.props.data;
    return <div>{franchiseInfo.name}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/nameFranchiseCellRenderer.jsx